// extracted by mini-css-extract-plugin
export default {"cardcontainer":"countries_cardcontainer__dMZ1M"};